export const paymentDescriptions = {
  0: 'Plan requires a minimum stay of your first prorated month and two additional full months. Plan will be billed and charged on the 1st of the month.',
  1: 'Paid on a monthly basis. Automatically renews on the 1st of the month.',
  6: 'Paid up front and automatically renews each 6 month period. Can be modified or cancelled up to 20 days before next billing date.',
  12: 'Paid up front and automatically renews each 12 month period. Can be modified or cancelled up to 20 days before next billing date.'
};
